'use client';
import React from 'react';
// import Image from 'next/image';
import toast from 'react-hot-toast';
import { useParams } from 'next/navigation';
import { validateEmail } from '@/lib/helpers/functions';
import { subscribeWithEmail } from '@/clients/customer/newsletter-subscribe';

// import rightImage from '../../../../public/vendor/update-2.png';
// import leftImage from '../../../../public/vendor/update-1.png';
import TermsAndCondition from '@/components/shared/TermsAndCondition';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useTranslations } from 'next-intl';
import { SectionHeader } from '@/components/ui/Typography';
import clsx from 'clsx';

type Props = {
  content?: ContentConfig['getUpdate'];
  contentClass?: string;
};

export default function VendorGetUpdate({ content, contentClass }: Props) {
  const [email, setEmail] = React.useState<string>('');
  const locale = useParams().locale;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const t = useTranslations();

  const showForm = content?.showForm ?? true;
  const contentWidthClasses = contentClass ?? 'lg:max-w-[50%]';

  const handleSubscribe = async () => {
    if (!email) {
      toast.error('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return;
    }
    if (!validateEmail(email)) {
      toast.error('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return;
    }

    const payload: any = {
      email,
      is_customer_type: false,
    };

    const token = await executeRecaptcha?.('newsletter');
    payload['g-recaptcha-response'] = token;

    toast.loading('Bitte warten...');

    subscribeWithEmail(payload, { ['Accept-Language']: locale })
      .then((res) => {
        toast.success(res.data.message);
        setEmail('');
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  return (
    <div id="update" className="bg-primary py-[50px] text-white">
      <div className="container">
        <div className="flex flex-col items-center">
          {/* <div className="relative h-[323px] w-[400px] lg:mb-[300px] lg:max-w-[25%] lg:self-start">
            <Image
              src={leftImage}
              fill
              sizes="100vw"
              className="floating object-cover"
              alt="update-left-image"
            />
          </div> */}

          <div
            className={clsx('text-center lg:self-center', contentWidthClasses)}
          >
            <SectionHeader className="mb-[21px] text-white">
              {content?.header ?? t('vendor_page.get_update.header')}
            </SectionHeader>
            {/* <h1 className="mb-[21px] text-[50px]/[1.3] font-[800] md:text-h1">
            </h1> */}
            <p className="text-h6">
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    content?.subheader ?? t('vendor_page.get_update.subheader'),
                }}
              ></span>
            </p>
            {showForm && (
              <div className="mx-auto mt-[41px] max-w-[574px] lg:mt-[47px] lg:flex lg:items-start lg:justify-center">
                <div className="relative mx-auto mb-[20px] w-[300px] md:w-[409px] lg:mb-0">
                  <input
                    type="email"
                    placeholder="maxmustermann@email.com"
                    aria-label={t('aria.email_for_subscription')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full rounded-[110px] border-none bg-white px-[30px] py-[12px] text-h6 text-paragraph shadow-[0px_14px_70px_rgba(0,0,0,0.1)] focus:border-none focus:outline-none focus:ring-0 lg:min-w-[200px]"
                  />
                  <div className="text-left">
                    <TermsAndCondition
                      btnText={t('subscribe_now')}
                      className="text-white"
                      linkclassName="text-white font-black"
                      lang={locale === 'en-DE' ? 'en' : 'de'}
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  onClick={handleSubscribe}
                  className="mt-[20px] shrink-0 rounded-[35px] border-2 border-transparent bg-white px-[20px] py-[11.5px] text-base text-primary-800  transition-colors duration-300 hover:border-2 hover:drop-shadow-lg md:mt-0 lg:ml-[20px]"
                >
                  {t('subscribe_now')}
                </button>
              </div>
            )}
          </div>

          {/* <div className="relative h-[333px] w-[411px] lg:max-w-[25%] lg:self-end">
            <Image
              src={rightImage}
              fill
              sizes="100vw"
              className="object-cover"
              alt="update-right-image"
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}
